import { useEffect } from "react";

import "./viewport-guard.scss";
import { useIsDesktopViewport } from "./helper";
import { IMAGES } from "../../common/constants";

const VIEWPORT_GUARD_MESSAGE =
  "The Databis Brand Portal is optimized for desktop and landscape tablet viewing. Please access from a larger device to continue.";

const ViewportGuard = () => {
  const isDesktopViewport = useIsDesktopViewport();

  useEffect(() => {
    if (!isDesktopViewport) {
      document.body.classList.add("bodyOverflowHidden");
      document.documentElement.classList.add("bodyOverflowHidden");
      window.scrollTo(0, 0);
    }

    return () => {
      document.body.classList.remove("bodyOverflowHidden");
      document.documentElement.classList.remove("bodyOverflowHidden");
    };
  }, [isDesktopViewport]);

  if (isDesktopViewport) {
    return null;
  }

  return (
    <div
      className="viewportGuardOverlay"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="viewport-guard-message"
    >
      <img src={IMAGES.Logo} alt="Databis Logo" />
      <p id="viewport-guard-message" className="viewportGuardMessage">
        {VIEWPORT_GUARD_MESSAGE}
      </p>
    </div>
  );
};

export default ViewportGuard;
